// extracted by mini-css-extract-plugin
export default {"leftBorder":"space-hierarchy_leftBorder__lkjFf","d-arrow":"space-hierarchy_d-arrow__qw5mj"};